import { fmlmReverseGeocode } from "../../../app/api/fmlmSearchLocation";
import { IApiResponse } from "../../../Orchestrator/Types/Index";

export interface ReverseGeocodeResult {
  name: string;
  place_formatted: string;
  coordinates: number[];
  country_code: string;
}

export async function getReverseGeocodedLocation(
  longitude: number,
  latitude: number
): Promise<ReverseGeocodeResult | null> {
  try {
    const response: IApiResponse<any> = await fmlmReverseGeocode(longitude, latitude);

    if (response.status === "ok") {
      const data = JSON.parse(response.answer);
      const feature = data?.features?.[0];

      if (feature) {
        return {
          name: feature?.properties?.name,
          place_formatted: feature?.properties?.place_formatted,
          coordinates: feature?.geometry?.coordinates,
          country_code: feature?.properties?.context?.country?.country_code
        };
      }
    }

    return null;
  } catch (error) {
    console.error("Error in getReverseGeocodedLocation:", error);
    throw error;
  }
}
